<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h5 class="card-title">Unterweisungen</h5>
          </div>
          <div class="col-md-auto text-right">
            <p-button type="success" @click="newUnterweisung" class="mt-0"><i class="bi bi-file-earmark-plus"></i> Neue Unterweisung</p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-collapse v-model="activeInstruction" accordion>
            <el-collapse-item v-for="u in instructions" :key="u.id" :name="u.id">
              <template slot="title">
                <div class="d-flex align-items-center w-100">
                  <div class="mr-3"><i class="bi bi-journal-text"></i></div>
                  <div class="flex-grow-1">{{ u.title }}</div>
                  <div class="text-muted" style="font-size: 12px;">{{ u.createdAtLabel }}</div>
                </div>
              </template>
              <div class="row">
                <div class="col-md-6">
                  <h6>Details</h6>
                  <p><b>Text:</b> {{ u.text || '-' }}</p>
                  <p><b>Dokumente: </b>
                    <span v-if="u.documents && u.documents.length">
                      <span v-for="doc in (u.documentTitles || [])" :key="doc">{{ doc }}<span v-if="!isLastDoc(u.documentTitles, doc)">, </span></span>
                    </span>
                    <span v-else>-</span>
                  </p>
                  <p><b>Optionen: </b>
                    <span v-if="u.options">
                      <span v-if="u.options.requestContactData">Kontaktdaten abfragen</span>
                      <span v-else>Kontaktdaten nicht abfragen</span>
                      |
                      <span v-if="u.options.requestEmergencyContact">Notfallkontakt abfragen</span>
                      <span v-else>Notfallkontakt nicht abfragen</span>
                    </span>
                    <span v-else>-</span>
                  </p>
                </div>
                <div class="col-md-6">
                  <h6>Status pro Mitarbeiter</h6>
                  <el-table :data="u.trainerStatuses" header-row-class-name="text-primary" empty-text="Keine Mitarbeiter zugewiesen." size="small">
                    <el-table-column prop="name" label="Mitarbeiter" min-width="160"></el-table-column>
                    <el-table-column prop="status" label="Status" min-width="120">
                      <template slot-scope="scope">
                        <span :class="scope.row.status === 'erledigt' ? 'text-success' : 'text-warning'">
                          <i :class="scope.row.status === 'erledigt' ? 'bi bi-check-circle-fill' : 'bi bi-hourglass-split'"></i>
                          {{ scope.row.status }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="completedAtLabel" label="Erledigt am" min-width="140"></el-table-column>
                    <el-table-column label="Unterschrift" min-width="120">
                      <template slot-scope="scope">
                        <div v-if="scope.row.signature">
                          <img :src="scope.row.signature" alt="Unterschrift" @click="showSignatureDialogFunction(scope.row)" style="max-height: 60px; max-width: 100px; border: 1px solid #ccc;"/>
                        </div>
                        <div v-else>
                          -
                        </div>
                      </template>
                      </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

    <!-- NEW Modal -->
    <el-dialog :title="TITLE" :visible.sync="newDialog" :close-on-click-modal="false" width="700px">
      <el-form label-position="top">
        <el-form-item label="Titel" required>
          <el-input v-model="form.title" placeholder="z.B. Betreuerschulung 2026"></el-input>
        </el-form-item>

        <el-form-item label="Mitarbeiter auswählen" required>
          <div class="mb-0 pt-0">
            <p-button class="mr-2 ml-1 mt-0 " @click="selectAllTrainers" type="link">Alle auswählen</p-button>
            <p-button class="mt-0 " @click="clearSelectedTrainers" type="link">Keine auswählen</p-button>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex flex-wrap">
                <label v-for="t in trainers" :key="t.key" class="mr-3 mb-2" style="cursor: pointer;">
                  <input type="checkbox" :value="t.key" v-model="form.trainers" />
                  <span class="ml-1">{{ t.trainerName }}</span>
                </label>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Text">
          <el-input type="textarea" v-model="form.text" :rows="4" placeholder="z.B. Hiermit bestätige ich, dass ich die Inhalter der Schulung zur Kenntnis genommen habe."></el-input>
        </el-form-item>

        <el-form-item label="Zu lesende Dokumente">
          <el-select v-model="form.documents" multiple filterable placeholder="Dokumente auswählen">
            <el-option v-for="d in documents" :key="d.key" :label="d.title" :value="d.key"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Optionen">
          <div class="form-check">
            <el-checkbox v-model="form.requestContactData">Kontaktdaten abfragen</el-checkbox>

          </div>
          <div class="form-check">
            <el-checkbox v-model="form.requestEmergencyContact">Notfallkontakt abfragen</el-checkbox>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <p-button @click="newDialog = false">Abbrechen</p-button>
        <p-button type="primary" @click="add">Speichern</p-button>
      </span>
    </el-dialog>

    <!-- Signature dialog -->
    <el-dialog title="Unterschrift" :visible.sync="showSignatureDialog" :close-on-click-modal="true">
      <img :src="dialogSignature.signature" alt="Unterschrift" style="max-width: 100%; max-height: 80vh;"/>
      <span>{{ dialogSignature.name }} - ({{ dialogSignature.completedAtLabel }} Uhr)</span>
      <span slot="footer" class="dialog-footer">
        <p-button @click="showSignatureDialog = false">Schließen</p-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Select, Option, Input, InputNumber, Collapse, CollapseItem, MessageBox, Dialog, Form, FormItem } from "element-ui";
import router from "../../../../main";
import moment from "moment-timezone";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    MessageBox,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
  },

  data() {
    return {
      TITLE: "Neue Unterweisung",
      location: store.getters.userlocation,
      role: store.getters.userrole,
      pickerOptions1: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Morgen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Woche",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 2 Wochen",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", date);
            },
          },
          {
            text: "In 1 Monat",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      instructions: [],
      activeInstruction: null,
      trainers: [],
      documents: [],
      newDialog: false,
      saving: false,
      showSignatureDialog: false,
      dialogSignature: {},
      form: {
        title: "",
        trainers: [],
        text: "",
        documents: [],
        requestContactData: false,
        requestEmergencyContact: false,
      },
    };
  },
  created() {
    this.load();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.load();
      }
    );
  },
  methods: {
    load() {
      this.loadSupportData();
      const ref = db.collection("unterweisungen");
      ref.where('locationID', '==', this.location).orderBy('createdAt', 'desc').onSnapshot((snap) => {
        const list = [];
        snap.forEach((doc) => {
          const data = doc.data();
          let createdAtLabel = '-';
          if (data.createdAt) {
            if (data.createdAt.seconds) {
              createdAtLabel = moment(new Date(data.createdAt.seconds * 1000)).format('DD.MM.YY HH:mm');
            } else {
              createdAtLabel = moment(new Date(data.createdAt)).format('DD.MM.YY HH:mm');
            }
          }
          list.push({
            id: doc.id,
            title: data.title,
            text: data.text || '',
            documents: data.documents || [],
            options: data.options || {},
            trainerIds: data.trainers || [],
            createdAtLabel,
            trainerStatuses: [],
            documentTitles: [],
          });
        });
        this.instructions = list;
        // Preload statuses and document titles for open item
        this.instructions.forEach((u) => {
          this.populateDocumentTitles(u);
          this.populateTrainerStatuses(u);
        });
      });
    },
    loadSupportData() {
      // trainers for selection
      const trainerRef = db.collection('trainer');
      trainerRef.where('locationID', 'array-contains', this.location).orderBy('Name').onSnapshot((snap) => {
        const tList = [];
        snap.forEach((doc) => {
          tList.push({ key: doc.id, trainerName: doc.data().Name });
        });
        this.trainers = tList;
      });
      // documents for selection
      const docsRef = db.collection('betriebsordner');
      docsRef.where('locationID', 'array-contains', this.location).orderBy('title').onSnapshot((snap) => {
        const dList = [];
        snap.forEach((doc) => {
          dList.push({ key: doc.id, title: doc.data().title });
        });
        this.documents = dList;
      });
    },
    populateDocumentTitles(u) {
      if (!u.documents || !u.documents.length) {
        u.documentTitles = [];
        return;
      }
      const promises = u.documents.map((docId) => db.collection('betriebsordner').doc(docId).get());
      Promise.all(promises).then((results) => {
        u.documentTitles = results.map((r) => (r.exists ? r.data().title : 'Unbekannt'));
      });
    },
    populateTrainerStatuses(u) {
      if (!u.trainerIds || !u.trainerIds.length) {
        u.trainerStatuses = [];
        return;
      }
      const statusPromises = u.trainerIds.map((trainerId) => {
        return db
          .collection('trainer')
          .doc(trainerId)
          .collection('unterweisungen')
          .doc(u.id)
          .get()
          .then((doc) => {
            return db.collection('trainer').doc(trainerId).get().then((tDoc) => {
              const name = tDoc.exists ? tDoc.data().Name : 'Unbekannt';
              let status = 'offen';
              let completedAtLabel = '-';
              let signature = doc.data().signature || null;
              if (doc.exists) {
                status = doc.data().status || 'offen';
                if (doc.data().ErledigtDatum) {
                  if (doc.data().ErledigtDatum.seconds) {
                    completedAtLabel = moment(new Date(doc.data().ErledigtDatum.seconds * 1000)).format('DD.MM.YY HH:mm');
                  } else {
                    completedAtLabel = moment(new Date(doc.data().ErledigtDatum)).format('DD.MM.YY HH:mm');
                  }
                }
              }
              return { trainerId, name, status, completedAtLabel, signature };
            });
          });
      });
      Promise.all(statusPromises).then((rows) => {
        u.trainerStatuses = rows;
      });
    },
    newUnterweisung() {
      this.resetForm();
      this.newDialog = true;
    },
    editTask(task) {
      this.dialogMode = "edit";
      this.newTaskTitle = task.taskName;
      this.newTaskDescription = task.taskDescription;
      this.newTaskDueDate = task.taskDueDate;
      this.newTaskAssignee = task.taskAssignee;
      this.editTaskKey = task.key;
      this.newTaskDialog = true;
    },
    add() {
      if (this.saving) { return; }
      if (!this.form.title || this.form.trainers.length === 0) {
        MessageBox.alert('Bitte Titel und mindestens einen Mitarbeiter wählen.', { type: 'warning' });
        return;
      }
      this.saving = true;
      const payload = {
        title: this.form.title,
        text: this.form.text || '',
        documents: this.form.documents || [],
        options: {
          requestContactData: !!this.form.requestContactData,
          requestEmergencyContact: !!this.form.requestEmergencyContact,
        },
        trainers: this.form.trainers,
        locationID: this.location,
        createdAt: new Date(),
      };
      db.collection('unterweisungen').add(payload).then((docRef) => {
        const instrId = docRef.id;
        const assignPromises = this.form.trainers.map((trainerId) => {
          return db
            .collection('trainer')
            .doc(trainerId)
            .collection('unterweisungen')
            .doc(instrId)
            .set({
              unterweisungId: instrId,
              title: this.form.title,
              status: 'offen',
              assignedAt: new Date(),
              ErledigtDatum: null,
              Token: this.generateToken(24),
            });
        });
        return Promise.all(assignPromises).then(() => instrId);
      }).then(() => {
        this.saving = false;
        this.newDialog = false;
        this.resetForm();
      }).catch((err) => {
        console.log('Error saving instruction', err);
        this.saving = false;
        MessageBox.alert('Die Unterweisung konnte nicht gespeichert werden.', { type: 'error' });
      });
    },
    resetForm() {
      this.form = {
        title: "",
        trainers: [],
        text: "",
        documents: [],
        requestContactData: false,
        requestEmergencyContact: false,
      };
    },
    selectAllTrainers() {
      this.form.trainers = this.trainers.map(t => t.key);
    },
    clearSelectedTrainers() {
      this.form.trainers = [];
    },
    isLastDoc(list, item) {
      if (!list) return true;
      return list[list.length - 1] === item;
    },
    generateToken(length = 24) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      if (window && window.crypto && window.crypto.getRandomValues) {
        const array = new Uint32Array(length);
        window.crypto.getRandomValues(array);
        for (let i = 0; i < length; i++) {
          result += chars[array[i] % chars.length];
        }
      } else {
        for (let i = 0; i < length; i++) {
          result += chars[Math.floor(Math.random() * chars.length)];
        }
      }
      return result;
    },
    showSignatureDialogFunction(signature) {
          this.dialogSignature = signature;
          this.showSignatureDialog = true;
        },
  },
};
</script>
<style>
  .el-form-item__label {
    font-weight: bold;
    line-height: normal !important;
  }
</style>
